import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface Props {
  width: string;
  height: string;
  fill: string;
}

function OutlineForwardIcon(props: Props): JSX.Element {
  const { width, height, fill } = props;
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          fill={fill}
          d="M9.62 12.547a.495.495 0 01-.353-.147.503.503 0 010-.707L12.96 8 9.267 4.307a.503.503 0 010-.707.503.503 0 01.706 0l4.047 4.047a.503.503 0 010 .706L9.973 12.4c-.1.1-.226.147-.353.147z"
        ></path>
        <path
          fill={fill}
          d="M13.553 8.5H2.333a.504.504 0 01-.5-.5c0-.273.227-.5.5-.5h11.22c.274 0 .5.227.5.5s-.226.5-.5.5z"
        ></path>
      </svg>
    </SVGUniqueID>
  );
}

OutlineForwardIcon.defaultProps = {
  width: '16',
  height: '16',
  fill: '#475569'
};

export { OutlineForwardIcon };
